<template>
  <div class="wrapper">
    <div class="bg-card">
      <div class="d-flex justify-content-between">
        <strong>{{ $t('pages.user-cv.my-recommendations.title', 'My recommendations') }}</strong>
        <b-button
          v-if="$route.name == 'my-cv'"
          class="cv-button"
          @click="$emit('recommendedByModalOpen')"
        >
          {{ $t('pages.user-cv.my-recommendations.edit-button', 'Edit my recommendations') }}
        </b-button>
      </div>
      <hr class="mb-0">
      <div>
        <div v-if="!recommendations">
          {{ $t('pages.user-cv.my-recommendations.modal.no-recommendations', 'No recommendations yet!') }}
        </div>
        <div
          v-for="recommendation in JSON.parse(recommendations)"
          :key="recommendation.id"
          class="mb-4"
        >
          <div class="row">
            <div class="col-12">
              <div class="mb-0">
                <span class="input-label">
                  {{ $t('inputs.first-name.title') }}:
                </span>
                <span style="font-size: 1rem !important; text-transform: uppercase">
                  {{ recommendation.name }}
                </span>
              </div>
              <div>
                <span class="input-label">
                  {{ $t('inputs.email.title') }}:
                </span>
                <span class="input-text">
                  {{ recommendation.email }}
                </span>
              </div>
              <div>
                <span class="input-label">
                  {{ $t('inputs.phone.title') }}:
                </span>
                <span class="input-text">
                  {{ recommendation.phone }}
                </span>
              </div>
              <div>
                <span class="input-label">
                  {{ $t('pages.user-cv.my-recommendations.text', 'Text') }}:
                </span>
                <span class="input-text">
                  {{ recommendation.text }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recommendations: {
      type: String,
      default: ""
    },
  }
}
</script>

<style lang="scss" scoped>
  .text-cv {
    white-space: pre-line;
  }
</style>
